import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "list-group" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "d-flex w-100 justify-content-between" }
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { class: "mb-1" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 4 }
const _hoisted_18 = { class: "text-right" }

import { computed, ref, reactive, watch, onMounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminManageRunsPage } from '@Integrations/Runs/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminManageRunsPage',
  setup(__props) {

    document.title = "Manage runs"

    const tid = useOrganizationUnitId()

    const { useCurrentUserQuery, useRunsOfOrganizationQuery } = useAdminManageRunsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelRunsOfOrganizationQueryV1, runRunsOfOrganizationQueryV1 } = useRunsOfOrganizationQuery(tid)
    const runs = computed(() => modelRunsOfOrganizationQueryV1.value?.Runs || [])

    onMounted(() => {
        runCurrentUserQueryV1()
        runRunsOfOrganizationQueryV1()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: _unref(tid) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-lg-7\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;\">Manage runs</h1></div><div class=\"col-lg-5 col-sm-6 text-right\"></div></div></div><hr style=\"border-color:#bbb;margin:20px 0 30px;\">", 2)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(runs.value, (r) => {
          return (_openBlock(), _createElementBlock("a", {
            key: r.RunId,
            href: `/#/admin/integrations/runs/details/${_unref(tid)}/${r.RunId}`,
            class: _normalizeClass(["list-group-item list-group-item-action", {'list-group-item-secondary': r.Queued, 'list-group-item-primary': r.Running, 'list-group-item-success': r.Succeed, 'list-group-item-danger': (r.Failed || r.Aborted) && !r.Succeed}])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("h6", _hoisted_6, [
                  (r.Running)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "[Running]"))
                    : (r.Succeed)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "[Succeed]"))
                      : (r.Failed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, "[Failed(" + _toDisplayString(r.FailuresCount) + ")]", 1 /* TEXT */))
                        : (r.Aborted)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "[Aborted]"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_11, "[Queued]")),
                  _createElementVNode("span", null, _toDisplayString(r.PipelineName), 1 /* TEXT */)
                ]),
                _createElementVNode("p", _hoisted_12, [
                  _createTextVNode(_toDisplayString(r.Trigger) + " ", 1 /* TEXT */),
                  (r.QueuedByName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "by " + _toDisplayString(r.QueuedByName), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("span", null, _toDisplayString(r.QueuedAtSinceNow) + " ago", 1 /* TEXT */),
                  (r.StartedAtSinceNow)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "/ started " + _toDisplayString(r.StartedAtSinceNow) + " ago", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (r.CompletedAtSinceNow)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "/ completed " + _toDisplayString(r.CompletedAtSinceNow) + " ago", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (r.FailedAtSinceNow)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "/ failed " + _toDisplayString(r.FailedAtSinceNow) + " ago", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (r.AbortedAtSinceNow)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "/ aborted " + _toDisplayString(r.AbortedAtSinceNow) + " ago", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("small", null, _toDisplayString(r.LastActivityAtSinceNow) + " ago", 1 /* TEXT */),
                _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _createElementVNode("small", null, _toDisplayString(r.Duration), 1 /* TEXT */)
              ])
            ])
          ], 10 /* CLASS, PROPS */, _hoisted_4))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}
}

})